<div class="assistant-overlay" (click)="onOverlayClick($event)">
  <div class="assistant-panel">

    <div class="panel-header">
      <div class="header-left">
        <div class="robot-avatar">
          <fa-icon [icon]="icons.wand"></fa-icon>
        </div>
        <div class="header-info">
          <h3>{{ 'ASSISTANT.TITLE' | translate }}</h3>
          <span class="step-indicator">
            {{ 'ASSISTANT.STEP' | translate }} {{ step }} {{ 'ASSISTANT.OF' | translate }} {{ totalSteps }}
          </span>
        </div>
      </div>
      <button class="close-btn" (click)="close()">
        <fa-icon [icon]="icons.times"></fa-icon>
      </button>
    </div>

    <div class="progress-track">
      <div class="progress-fill" [style.width.%]="100">
        <div class="progress-shine"></div>
      </div>
    </div>

    <div class="panel-body">

      <div class="assistant-bubble intro-bubble">
        <fa-icon [icon]="icons.robot" class="bubble-icon"></fa-icon>
        <p>{{ introKey | translate }}</p>
      </div>

      <form [formGroup]="chatForm">
        <div class="step-block">
          <div class="assistant-bubble question-bubble">
            <fa-icon [icon]="icons.robot" class="bubble-icon"></fa-icon>
            <p>{{ 'ASSISTANT.ARCHIVE_QUESTION' | translate }}</p>
          </div>

          <div class="input-group">
            <label class="input-label">{{ 'ASSISTANT.ARCHIVE_LABEL' | translate }}</label>
            <ng-select [items]="archives" bindLabel="name" bindValue="id" [formControl]="archiveControl"
              [notFoundText]="'NG_SELECT.NO_ITEMS_FOUND' | translate" [clearable]="true" [searchable]="true"
              [multiple]="true" appendTo="body" class="assistant-ng-select">
              <ng-template ng-option-tmp let-item="item">
                <div class="archive-option">
                  <fa-icon [icon]="icons.file" class="file-icon"></fa-icon>
                  <span>{{ item.name }}</span>
                </div>
              </ng-template>
              <ng-template ng-label-tmp let-item="item" let-clear="clear">
                <span class="archive-chip-label" [title]="item.name">{{ item.name }}</span>
                <button type="button" class="archive-chip-remove"
                  [attr.aria-label]="'Remover ' + item.name"
                  (mousedown)="$event.preventDefault(); $event.stopPropagation()"
                  (click)="clear(item); $event.stopPropagation()">×</button>
              </ng-template>
            </ng-select>
          </div>
        </div>

        @if (showOcrFeaturesSelector) {
        <div class="step-block">
          <div class="assistant-bubble question-bubble">
            <fa-icon [icon]="icons.robot" class="bubble-icon"></fa-icon>
            <p>{{ 'ASSISTANT.OCR_FEATURES_QUESTION' | translate }}</p>
          </div>

          <div class="input-group">
            <label class="input-label">{{ 'ASSISTANT.OCR_FEATURES_LABEL' | translate }}</label>
            <ng-select [items]="ocrFeaturesConfigs" bindLabel="display_label" bindValue="id"
              formControlName="ocr_features_config_id"
              [notFoundText]="'NG_SELECT.NO_ITEMS_FOUND' | translate" [clearable]="true" [searchable]="true"
              appendTo="body" class="assistant-ng-select">
              <ng-template ng-option-tmp let-item="item">
                <span>{{ getConfigurationLabel(item) }}</span>
              </ng-template>
              <ng-template ng-label-tmp let-item="item">
                <span>{{ getConfigurationLabel(item) }}</span>
              </ng-template>
            </ng-select>
          </div>
        </div>
        }

        @if (delfosLlmConfigs.length > 1) {
        <div class="step-block">
          <div class="assistant-bubble question-bubble">
            <fa-icon [icon]="icons.robot" class="bubble-icon"></fa-icon>
            <p>{{ 'ASSISTANT.LLM_MODEL_QUESTION' | translate }}</p>
          </div>

          <div class="input-group">
            <label class="input-label">{{ 'ASSISTANT.LLM_MODEL' | translate }}</label>
            <ng-select [items]="delfosLlmConfigs" bindLabel="display_label" bindValue="id"
              [(ngModel)]="selectedDelfosLlmId"
              [ngModelOptions]="{ standalone: true }"
              [notFoundText]="'NG_SELECT.NO_ITEMS_FOUND' | translate" [clearable]="true" [searchable]="true"
              appendTo="body" class="assistant-ng-select">
              <ng-template ng-option-tmp let-item="item">
                <span>{{ getConfigurationLabel(item) }}</span>
              </ng-template>
              <ng-template ng-label-tmp let-item="item">
                <span>{{ getConfigurationLabel(item) }}</span>
              </ng-template>
            </ng-select>
          </div>
        </div>
        }

        @if (showCacheOptions) {
        <div class="cache-options-row">
          <label class="cache-option">
            <input type="checkbox" [(ngModel)]="clearDelfosCache" [ngModelOptions]="{ standalone: true }">
            <span>{{ 'ASSISTANT.CLEAR_DELFOS_CACHE_LABEL' | translate }}</span>
          </label>
          <label class="cache-option">
            <input type="checkbox" [(ngModel)]="clearOcrCache" [ngModelOptions]="{ standalone: true }">
            <span>{{ 'ASSISTANT.CLEAR_OCR_CACHE_LABEL' | translate }}</span>
          </label>
        </div>
        }
      </form>
    </div>

    <div class="panel-footer">
      <div></div>
      <button class="btn-generate" (click)="generateResult()" [disabled]="loading || chatForm.invalid">
        @if (loading) {
        <fa-icon [icon]="icons.spinner" class="spin-icon"></fa-icon>
        <span>{{ 'ASSISTANT.GENERATING' | translate }}</span>
        } @else {
        <fa-icon [icon]="icons.wand"></fa-icon>
        <span>{{ 'ASSISTANT.GENERATE' | translate }}</span>
        }
      </button>
    </div>

  </div>
</div>
